"use client";

import { X } from "lucide-react";

import { useStyles } from "./styles";

interface OptionBadgesProps {
  selectedModes: {
    isPublic: boolean;
    is18Plus: boolean;
    isTextImage: boolean;
  };
  images: File[];
  setImages: (images: File[]) => void;
  totalImages: number;
}

const OptionBadges: React.FC<OptionBadgesProps> = ({
  selectedModes,
  images,
  setImages,
  totalImages,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.container}>
      <div className={cx(classes.badge, classes.images)}>
        {totalImages} Image{totalImages > 1 ? "s" : ""}
      </div>
      {selectedModes.isPublic && (
        <div className={cx(classes.badge, classes.public)}>Public</div>
      )}
      {selectedModes.is18Plus && (
        <div className={cx(classes.badge, classes.over18)}>18+</div>
      )}
      {selectedModes.isTextImage && (
        <div className={cx(classes.badge, classes.text)}>Text</div>
      )}
    </div>
  );
};

export default OptionBadges;
